import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchGeneralUserRoles = createAsyncThunk("fetchGeneralUserRoles", async () => {
	const response = await axiosHttp.get("roles/list");
	return response.data.data;
});

const GeneralUserRolesSlice = createSlice({
	name: "GeneralUserRolesSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchGeneralUserRoles.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchGeneralUserRoles.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchGeneralUserRoles.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GeneralUserRolesSlice.reducer;
